import { Icon } from '@/components/ui/icon';

export interface InfoWarningLine {
  icon: string;
  text: string;
}

export interface InfoWarningCardProps {
  lines: InfoWarningLine[];
}

/**
 * The light "Info warning" card beneath the EDP title — one icon+text row per
 * booking condition (courtesy/free, prior-booking-required, ticket limits...).
 * No existing component matches this light-card shape (distinct from the dark
 * hero `BookingDetailInfo` rows), so it's built to match the fetched design directly.
 */
export function InfoWarningCard({ lines }: InfoWarningCardProps) {
  if (lines.length === 0) return null;

  return (
    <div className="bg-jncquoi-neutral-50 flex w-full flex-col items-start justify-center gap-2 px-4 py-2">
      {lines.map((line, i) => (
        <div key={i} className="flex w-full items-center gap-2">
          <Icon name={line.icon} width={20} height={20} className="text-jncquoi-neutral-800 shrink-0" />
          <span className="font-pp-neue-montreal text-jncquoi-neutral-800 min-w-0 flex-1 text-[12px] tracking-[0.5px]">
            {line.text}
          </span>
        </div>
      ))}
    </div>
  );
}
